const FileTypeCode  = Object.freeze({
  INSURANCE_CARD_FRONT: 'insurance card front',
  INSURANCE_CARD_BACK: 'insurance card back',
  MEDICAL_RECORD: 'medical record',
  REQUISITION_FORM: 'requisition form',
  OTHER: 'other'
})

export default FileTypeCode;